var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home position-relative"},[_c('Map',{attrs:{"latCenter":48.22830617300693,"lngCenter":17.402899096256306}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }